'use strict';

var defineProperty = require('../../../node_modules/@babel/runtime/helpers/defineProperty.js');
var objectWithoutProperties = require('../../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js');
var React = require('react');
var makeStyles = require('../../Styles/makeStyles.js');
var classNames = require('classnames');
var Badge = require('../../../node_modules/@material-ui/core/esm/Badge/Badge.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var useStyles = makeStyles["default"](function (theme) {
  return {
    sizes: function sizes(props) {
      return {
        minHeight: props.minSizes,
        minWidth: props.minSizes,
        borderRadius: props.minSizes / 2
      };
    },
    badgeColor: function badgeColor(_ref) {
      var _theme$palette$color, _theme$palette$color2;

      var color = _ref.color;
      return {
        backgroundColor: ((_theme$palette$color = theme.palette[color]) === null || _theme$palette$color === void 0 ? void 0 : _theme$palette$color.main) || theme.palette.primary.main,
        color: ((_theme$palette$color2 = theme.palette[color]) === null || _theme$palette$color2 === void 0 ? void 0 : _theme$palette$color2.contrastText) || theme.palette.primary.contrastText
      };
    },
    beacon: function beacon(props) {
      var _theme$palette$props$;

      return {
        '&:before': {
          content: "''",
          height: props.minSizes / 2,
          width: props.minSizes / 2,
          backgroundColor: 'transparent',
          borderRadius: '50%',
          boxShadow: "0px 0px 2px 2px ".concat(((_theme$palette$props$ = theme.palette[props.color]) === null || _theme$palette$props$ === void 0 ? void 0 : _theme$palette$props$.main) || theme.palette.primary.main)
        }
      };
    },
    beaconSizes: function beaconSizes(props) {
      return {
        minHeight: props.minSizes / 2,
        minWidth: props.minSizes / 2,
        borderRadius: props.minSizes / 4
      };
    },
    beaconAnimation: {
      '&:before': {
        animation: '$beacon 2s infinite linear'
      }
    },
    '@keyframes beacon': {
      '0%': {
        transform: 'scale(0)',
        opacity: 1
      },
      '70%': {
        transform: 'scale(2.5)',
        opacity: 0
      },
      '100%': {
        opacity: 0
      }
    }
  };
});

var BadgeBase = function BadgeBase(_ref2) {
  var _classNames;

  var classes = _ref2.classes,
      _ref2$version = _ref2.version,
      version = _ref2$version === void 0 ? '' : _ref2$version,
      children = _ref2.children,
      color = _ref2.color,
      variant = _ref2.variant,
      restProps = objectWithoutProperties(_ref2, ["classes", "version", "children", "color", "variant"]);

  var isV2 = version === 'v2';
  var isStandardVariant = variant === 'standard';
  var isBeaconVariant = variant === 'beacon';
  var minSizes = isStandardVariant ? 24 : 16;

  var _useStyles = useStyles({
    color: color,
    minSizes: minSizes,
    variant: variant
  }),
      sizes = _useStyles.sizes,
      badgeColor = _useStyles.badgeColor,
      beacon = _useStyles.beacon,
      beaconSizes = _useStyles.beaconSizes,
      beaconAnimation = _useStyles.beaconAnimation;

  return React__default["default"].createElement(Badge["default"], _objectSpread({
    classes: {
      badge: classNames__default["default"](classes, (_classNames = {}, defineProperty(_classNames, sizes, isV2 && !isBeaconVariant), defineProperty(_classNames, badgeColor, isV2), defineProperty(_classNames, beacon, isBeaconVariant), defineProperty(_classNames, beaconSizes, isV2 && isBeaconVariant), defineProperty(_classNames, beaconAnimation, isBeaconVariant), _classNames))
    },
    color: isV2 ? 'default' : color,
    variant: isBeaconVariant ? 'dot' : variant
  }, restProps), children);
};

module.exports = BadgeBase;
